/*
 *
 * TimeSlotPage reducer
 *
 */
import {fromJS} from "immutable";
import {
  CLEAR_MODIFY_TIME_SLOT_FAILED,
  DEFAULT_ACTION,
  DELETE_APPOINTMENT,
  DELETE_APPOINTMENT_FAILED,
  DELETE_APPOINTMENT_SUCCESS,
  DELETE_TIME_SLOT,
  DELETE_TIME_SLOT_FAILED,
  DELETE_TIME_SLOT_SUCCESS,
  GET_PLANNED_DAYS,
  GET_PLANNED_DAYS_FAILED,
  GET_PLANNED_DAYS_SUCCESS,
  GET_TIME_SLOT,
  GET_TIME_SLOT_FAILED,
  GET_TIME_SLOT_SUCCESS,
  MODIFY_TIME_SLOT,
  MODIFY_TIME_SLOT_FAILED,
  MODIFY_TIME_SLOT_SUCCESS,
  MOVE_TREATMENT,
  MOVE_TREATMENT_FAILED,
  MOVE_TREATMENT_SUCCESS,
  RESET_LOADING,
} from "./constants";
import {deletePlannedDayTreatment, movePlannedDayTreatment} from "./utils";

export const initialState = fromJS({
  timeSlot: null,
  timeSlotLoading: false,
  deleted: false,
  movingTreatment: false,
  movingTreatmentError: false,

  // Delete timeSlot
  deleteLoading: false,
  deleteTimeSlotLoading: false,
  deletingTimeSlot: null,

  // Editing timeSlot
  timeSlotEditing: false,
  timeSlotEditFailed: null,

  // Planned days
  plannedDays: undefined,
  oldPlannedDays: undefined,
  plannedDaysLoading: false,
});

function timeSlotPageReducer(state = initialState, action) {
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;
    /**
     * Get timeSlot
     */
    case GET_TIME_SLOT:
      return state.set("timeSlotLoading", true).set("deleted", false);
    case GET_TIME_SLOT_SUCCESS:
      return state
        .set("timeSlotLoading", false)
        .set("timeSlot", action.result)
        .set("deleted", false)
        .set("timeSlotEditFailed", null);
    case GET_TIME_SLOT_FAILED:
      return state
        .set("timeSlotLoading", false)
        .set("timeSlot", null)
        .set("deleted", false)
        .set("timeSlotEditFailed", null);
    /**
     * Delete timeSlot
     */
    case DELETE_TIME_SLOT:
      return state
        .set("deleteTimeSlotLoading", true)
        .set("deletingTimeSlot", action.timeSlot);
    case DELETE_TIME_SLOT_FAILED:
      return state
        .set("deleteTimeSlotLoading", false)
        .set("deletingTimeSlot", null);
    case DELETE_TIME_SLOT_SUCCESS: {
      const timeSlot = state.get("deletingTimeSlot");
      const plannedDay = state.get("plannedDays");
      if (!timeSlot || !plannedDay) {
        return state;
      }
      const index = plannedDay.plannedTimeSlots.findIndex(
        t => t.id === timeSlot.id,
      );
      if (index === -1) {
        return state;
      }
      plannedDay.plannedTimeSlots.splice(index, 1);
      return state
        .set("plannedDays", plannedDay)
        .set("deletingTimeSlot", null)
        .set("deleteTimeSlotLoading", false);
    }
    /**
     * Modify timeSlot
     */
    case MODIFY_TIME_SLOT:
      return state.set("timeSlotEditing", true).set("timeSlotEditFailed", null);
    case MODIFY_TIME_SLOT_FAILED:
      return state.set("timeSlotEditing", false).set("timeSlotEditFailed", {
        actionId: action.actionId,
        message: action.message,
      });
    case MODIFY_TIME_SLOT_SUCCESS: {
      const plannedDay = state.get("plannedDays");
      const timeSlots = plannedDay.plannedTimeSlots.slice();
      const index = timeSlots.findIndex(t => t.id === action.result.id);
      if (index === -1) {
        // Make sure the timeSlot is present.
        return state;
      }
      // Modify the timeSlot
      timeSlots[index] = {
        ...timeSlots[index],
        ...action.result,
        plannedTreatments: timeSlots[index].plannedTreatments.slice(),
      };
      // Update the plannedDay
      return state
        .set("plannedDays", {
          ...plannedDay,
          plannedTimeSlots: timeSlots,
        })
        .set("timeSlotEditing", false)
        .set("timeSlotEditFailed", null);
    }
    case CLEAR_MODIFY_TIME_SLOT_FAILED:
      return state.set("timeSlotEditFailed", null);
    /**
     * Planned days
     */
    case GET_PLANNED_DAYS:
      return state.set("plannedDaysLoading", true).set("movingTreatmentError", false);
    case GET_PLANNED_DAYS_FAILED:
      return state.set("plannedDaysLoading", false).set("plannedDays", {});
    case GET_PLANNED_DAYS_SUCCESS:
      return state
        .set("plannedDaysLoading", false)
        .set("plannedDays", action.result);
    /**
     * Move treatment
     */
    case MOVE_TREATMENT: {
      // Move the treatment.
      const plannedDay = state.get("plannedDays");
      const oldPlannedDay = JSON.parse(JSON.stringify(plannedDay));;
      const newPlannedDay = movePlannedDayTreatment(
        plannedDay,
        action.treatment,
      );

      // Update the state.
      const _state = state.set("movingTreatment", true);
      if (!newPlannedDay) {
        return _state;
      }
      return _state.set("plannedDays", newPlannedDay).set("movingTreatmentError", false).set("oldPlannedDays", oldPlannedDay);
    }
    case MOVE_TREATMENT_SUCCESS:
      return state.set("movingTreatment", false).set("movingTreatmentError", false);
    case MOVE_TREATMENT_FAILED:
      const oldPlannedDay = state.get("oldPlannedDays");
      return state.set("movingTreatment", false).set("movingTreatmentError", true).set("plannedDays", oldPlannedDay);
    /**
     * Delete appointment
     */
    case DELETE_APPOINTMENT:
      return state.set("deleteLoading", true);
    case DELETE_APPOINTMENT_FAILED:
      return state.set("deleteLoading", false);
    case DELETE_APPOINTMENT_SUCCESS: {
      const plannedDay = state.get("plannedDays");
      const _state = state.set("deleteLoading", false);
      const newPlannedDay = deletePlannedDayTreatment(
        plannedDay,
        action.result.appointment,
      );

      if (!newPlannedDay) {
        return _state;
      }
      return _state.set("plannedDays", newPlannedDay);
    }

    case RESET_LOADING:
      return state
        .set("deleteLoading", false)
        .set("plannedDaysLoading", false)
        .set("deleteTimeSlotLoading", false);

    default:
      return state;
  }
}

export default timeSlotPageReducer;
